export default __webpack_public_path__ + "static/media/spicy.2857cca3.svg";